/**
 * Sort option metadata for the auction listing sections.
 *
 * Each listing section ("active" live auctions vs "sold") exposes its own set
 * of sort options. The ordering itself happens server-side in Meilisearch: the
 * chosen key lives in the URL (`live_sort` / `sold_sort`) so it is shareable and
 * survives a refresh, defaulting per variant when the param is absent.
 */

export const SORT_OPTIONS = {
    active: [
        { value: "ending_soon", label: "Ending Soon" },
        { value: "bids_low", label: "Bids: Low to High" },
        { value: "bids_high", label: "Bids: High to Low" },
        { value: "newest_listing", label: "Newest to Oldest Listing" },
    ],
    sold: [
        { value: "recently_sold", label: "Most Recently Sold" },
        { value: "bids_low", label: "Bids: Low to High" },
        { value: "bids_high", label: "Bids: High to Low" },
        { value: "newest_listing", label: "Newest to Oldest Listing" },
    ],
}

export const DEFAULT_SORT = {
    active: "ending_soon",
    sold: "recently_sold",
}

/** Map a PaginatedFirearmGrid `pageName` to its sort variant. */
export const variantForPage = (pageName) =>
    pageName === "sold_page" ? "sold" : "active"

/** Map a PaginatedFirearmGrid `pageName` to its server-side sort query param. */
export const sortParamForPage = (pageName) =>
    pageName === "sold_page" ? "sold_sort" : "live_sort"
